import { Component, OnInit, Input } from '@angular/core';
import { Project, ProjectEmployee, Partecipant, PartecipantType } from 'toolbandi-ui-lib';
import { Search, CrudService, MessageService } from 'elbuild-ui-lib-core';
import { forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap/';
import { ProjectEmployeeAddComponent } from '../project-employee-add/project-employee-add.component';
import { DialogService } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-project-employee-list',
	templateUrl: './project-employee-list.component.html',
	styleUrls: ['./project-employee-list.component.scss']
})
export class ProjectEmployeeListComponent implements OnInit {

	@Input()
	projectid: number;

	@Input()
	tenderid: number;

	@Input()
	companyid: number;
	project: Project;
	partecipant: Partecipant;


	loading: boolean = false;
	rows: ProjectEmployee[];

	advancedSearch = new Search('projectemployee join employee on projectemployee.employeeid = employee.id');
	selectedProjectEmployee: ProjectEmployee;

	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	constructor(
		private employeeService: CrudService<ProjectEmployee>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private modalService: NgbModal,
		private dialogService: DialogService,
		private projectService: CrudService<Project>,
		private partecipantService: CrudService<Partecipant>
	) {
		this.advancedSearch.addSimpleFilter('projectid', this.projectid);

	}

	ngOnInit() {
		this.loadEmployees();
		this.loadPartecipant();
		if (this.projectid) {
			this.projectService.getEntity(Project, 'project', this.projectid).subscribe((p: Project) => this.project = p);
		}
	}

	loadPartecipant(): void {
		const search = new Search('partecipant');
		search.addSimpleFilter('projectid', this.projectid);
		search.addSimpleFilter('entity', PartecipantType.COMPANY);
		search.addSimpleFilter('eid', this.companyid);

		this.partecipantService.searchEntities(Partecipant, 'partecipant', search, search.page).subscribe((p: Partecipant[]) => {
			this.partecipant = p[0];
			this.partecipant.entityobj = undefined;
		});
	}

	loadEmployees(): void {
		this.loading = true;
		this.rows = [];


		if (this.projectid) {
			this.advancedSearch.addSimpleFilter('projectemployee.projectid', this.projectid);
		}

		if (this.companyid) {
			this.advancedSearch.addSimpleFilter('employee.companyid', this.companyid);
		}

		const datarequest = this.employeeService.searchEntities(ProjectEmployee, 'projectemployee', this.advancedSearch, this.advancedSearch.page);
		const countrequest = this.employeeService.countEntities(ProjectEmployee, 'projectemployee', this.advancedSearch);

		forkJoin([datarequest, countrequest]).subscribe(results => {
			this.advancedSearch.page.setTotal(results[1].ct);
			this.rows = results[0];
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}

	onPageChange(pageInfo: any) {
		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.loadEmployees();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.loadEmployees();
	}

	delete(employee: ProjectEmployee): void {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-employee-remove'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.employeeService.deleteEntity(ProjectEmployee, 'projectemployee', employee).subscribe(() => {
					this.translateService.get(['labels.employee-removed', 'labels.employees']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.employee-removed'], messages['labels.employees']);
						this.loadEmployees();
					});
				});
			}
		});

	}

	add(): void {

		const modal = this.modalService.open(ProjectEmployeeAddComponent, {
			centered: true,
			size: 'xl',
			backdrop: 'static',
			keyboard: false
		});
		modal.componentInstance.projectid = this.projectid;
		if (this.companyid) {
			modal.componentInstance.singlecompany = true;
			modal.componentInstance.companyid = this.companyid;
		}
		modal.componentInstance.loadAssociableEmployees();
		modal.componentInstance.loadAssociateEmployees();


		modal.result.then(() => {
			this.loadEmployees();
		}).catch(() => {
			this.loadEmployees();
		});

	}

	updateManager(row: ProjectEmployee): void {
		if (this.project.isDraft) {
			if (row.employeeid !== this.partecipant.manager) {
				this.partecipant.manager = row.employeeid;
				this.partecipantService.saveEntity(Partecipant, 'partecipant', this.partecipant).subscribe((p: Partecipant) => {
					this.messageService.sendSuccess(this.translateService.instant('labels.manager-save-success'));
				}, ({ error }) => {
					this.messageService.sendError(
						error.msg ? error.msg : error,
						this.translateService.instant('labels.event-save-error')
					);
				});
			}

		}
	}



	openFileGeneratorModal(row: ProjectEmployee, content: any) {
		this.selectedProjectEmployee = row;

		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });

	}


}
